import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { ElementRef, AfterViewInit } from '@angular/core';

import { NgModel, NgControl } from '@angular/forms';

declare var $;

@Directive({
  selector: '[color-picker]',
  providers: [NgModel]
})

export class ColorPickerDirective implements AfterViewInit {
  $redactorElement: any;
  public color: any;

  @Input('color') 
  set setColor(color: any) {
    this.color = color;
    if (this.$redactorElement) {
      $(this.$redactorElement).spectrum("set", color).trigger('change', { fromComponent: true });
    }
  }

  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private el: ElementRef,
    private control?: NgControl
  ) { }

  ngAfterViewInit(): void {
    let $this = this;
    this.$redactorElement = this.el.nativeElement;
    $(this.$redactorElement).spectrum({
      color: this.color ? this.color : '#000000',
      // move: function (color) {
      //   $this.color = color.toHexString();
      //   $this.onInputChange(color.toHexString());
      //   console.log('move', color);
      // },
      change: function (color) {
        $this.color = color.toHexString();
        $this.onInputChange(color.toHexString());
      },
      hide: function (color) {
        $this.color = color.toHexString();
        $this.onInputChange(color.toHexString());
      },
    });
  }

  onInputChange(color) {
    if (this.control) {
      this.control.control.setValue(color);
    } else {
      this.ngModelChange.emit(color);
    }
  }

}
